import React, { useEffect, useState } from "react";
import { useProvider, Toast } from "../context/MenuProvider";
import { Spinner, Button } from "react-bootstrap";
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';

const ConsultorItem = ({ consultor, carregarDownlines }) => {
  const [expandido, setExpandido] = useState(false);
  const [downlines, setDownlines] = useState([]);
  const [nextDownUrl, setNextDownUrl] = useState(null);
  const [dados, setDados] = useState(consultor); // manter estado local
  const [loading, setLoading] = useState(true); // manter estado local
  const { crudAdmin } = useProvider();
  const { patch } = crudAdmin || {};

  const toggleAtivar = async () => {
    try {
      Swal.fire({
        title: "Pegou combo?",
        text: `${consultor?.contato?.none_do_cliente || consultor?.nome} já pegou combo de trabalho?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await patch({ pre_cadastro: false }, `/rede/consultores/${dados.id}/`, null, 'salvar');
            if(response && response.length){
              setDados((prev) => ({ ...prev, ...response[0] }));
              Toast.fire({
                  icon: "success",
                  title: `Ativo com sucesso`
              });
            }
          }catch(err){
            console.error("Erro ao ativar consultor:", err);
          }
        }
      });
    } catch (err) {
      console.error("Erro ao ativar consultor", err);
    }
  };
  
  const toggleExpand = async () => {
    if (!expandido) {
      const { results, next } = await carregarDownlines(dados.id);
      setDownlines(results);
      setNextDownUrl(next);
      setLoading(false);
    }
    setExpandido(!expandido);
  };

  const carregarMais = async () => {
    if (nextDownUrl) {
      const { results, next } = await carregarDownlines(dados.id, nextDownUrl);
      setDownlines((prev) => [...prev, ...results]);
      setNextDownUrl(next);
    }
  };

  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between align-items-center border p-2 rounded">
        <Link 
          to={`/rede/equipe/${dados.id}/editar`} 
          className="text-decoration-none"
        >
          {dados?.pre_cadastro && (<>*</>)}{dados?.nome || dados.contato?.nome_do_cliente || dados.codigo}
        </Link>
        
        <div>
          {dados?.pre_cadastro && (
            <Button
              variant="outline-primary"
              className="btn btn-sm ms-2"
              onClick={toggleAtivar}
            >
              Ativar
            </Button>
          )}
          <Button
            variant="outline-primary"
            className="btn btn-sm ms-2"
            onClick={toggleExpand}
          >
            {expandido 
              ? <i className="bx bx-chevron-up"></i> 
              : <i className="bx bx-chevron-down"></i>}
          </Button>
        </div>
      </div>

      {expandido && downlines.length > 0 && (
        <div 
          className="ms-1 ps-1 mt-2" 
          style={{ borderLeft: "2px solid lightgray" }}
        >
          {downlines.map((d) => (
            <ConsultorItem
              key={d.id}
              consultor={d}
              carregarDownlines={carregarDownlines}
            />
          ))}

          {nextDownUrl && (
            <div className="ms-4 mt-2">
              <Button 
                variant="outline-secondary" 
                size="sm" 
                onClick={carregarMais}
              >
                Carregar mais
              </Button>
            </div>
          )}
        </div>
      )}

      {expandido && !loading && downlines.length === 0 && (
        <p className="text-muted ms-1 ps-1 mt-1" style={{ borderLeft: "2px solid lightgray" }}>Sem downlines</p>
      )}
    </div>
  );
};

const Equipe = () => {
  const { crudAdmin } = useProvider();
  const { get, loading } = crudAdmin || {};
  const [consultores, setConsultores] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);

  const buscarConsultores = async (url = `/rede/consultores/?ordering=nome&expand=contato&upline__isnull=true`) => {
    try {
      const response = await get(url, "pagina");
      if (response && response[0]?.results) {
        setConsultores((prev) => [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      }
    } catch (err) {
      console.error("Erro ao buscar consultores:", err);
    }
  };

  const carregarDownlines = async (consultorId, url = null) => {
    try {
      const finalUrl = url || `/rede/consultores/?ordering=nome&expand=contato&upline=${consultorId}`;
      const response = await get(finalUrl, "pagina");
      if (response && response[0]?.results) {
        return {
          results: response[0].results,
          next: response[0].next,
        };
      }
      return { results: [], next: null };
    } catch (err) {
      console.error("Erro ao buscar downlines:", err);
      return { results: [], next: null };
    }
  };

  useEffect(() => {
    buscarConsultores();
  }, []);

  // Scroll infinito para os consultores raiz
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        if (!loading && nextUrl) buscarConsultores(nextUrl);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);

  return (
    <div>
      {!loading && consultores.length === 0 && (
        <p className="text-center text-muted">Nenhum consultor encontrado.</p>
      )}
      <BotaoFlutuante to="/rede/equipe/novo" icon="bi-plus"></BotaoFlutuante>
      <div>
        {consultores.map((c) => (
          <ConsultorItem
            key={c.id}
            consultor={c}
            carregarDownlines={carregarDownlines}
          />
        ))}
      </div>
      {loading && <p className="text-center"><Spinner animation="border" /></p>}
    </div>
  );
};

export default Equipe;